import ToolMark from './ToolMark';
import FontSizePicker from '../FontSizePlugin/components/FontSizePicker';

// Toggles a text color mark (color style) on the currently selected elements.
class ToolFontSize extends ToolMark {
  static toolName = 'Font size';
  static iconClass = 'fa-regular fa-text-size';
  static mark = 'fontSize' as const;

  static toolbarSubmenu() {
    return FontSizePicker;
  }
}

export default ToolFontSize;
